import CustomerDetailActivityLogsSection from "./CustomerDetailActivityLogsSection";
import CustomerDetailOrdersSection from "./CustomerDetailOrdersSection";
import CustomerDetailProfileSection from "./CustomerDetailProfileSection";
import CustomerDetailTransactionsSection from "./CustomerDetailTransactionsSection";

function CustomerDetailContentSection({ tab, data, callback }) {
  switch (tab) {
    case "profile":
      return <CustomerDetailProfileSection data={data} callback={callback} />;
    case "transaction":
      return <CustomerDetailTransactionsSection data={data} />;
    case "order":
      return <CustomerDetailOrdersSection data={data} />;
    case "log":
      return <CustomerDetailActivityLogsSection data={data} />;
    default:
      return <div></div>;
  }
}

export default CustomerDetailContentSection;
